import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import "./ConsumerHeader.css";

/**
 * Header for the consumer-facing pages.
 *
 * The shared Header component is the attorney product nav — Research, Debate
 * Mode, Pricing, Settings, Login. None of that applies to a member of the
 * public asking a legal question, so these pages get their own nav per the
 * design: Ask a Question, Find an Attorney, and a route back to the splitter
 * for anyone who landed here but is actually a legal professional.
 *
 * @param {boolean} minimal - logo only, used on the splitter itself
 */
export default function ConsumerHeader({ minimal = false }) {
  const { darkMode } = useTheme();
  const { pathname } = useLocation();

  const links = [
    { to: "/ask", label: "Ask a Question" },
    { to: "/find-attorney", label: "Find an Attorney" },
    // Straight to the attorney homepage, not back to the splitter the visitor
    // has already been through.
    { to: "/attorneys", label: "Are You an Attorney or Paralegal?" },
  ];

  return (
    <header className={`ch-header ${darkMode ? "ch-dark" : ""}`}>
      <nav className="ch-nav">
        {/* Same mark as the attorney header (Header.js uses /logo.png) so the
            brand reads identically across both sides of the product, and it
            goes to the landing page rather than the audience splitter. */}
        <Link to="/" className="ch-logo">
          <img src="/logo.png" alt="LawFusion" className="ch-logo-img" />
        </Link>

        {!minimal && (
          <div className="ch-links">
            {links.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={`ch-link ${pathname === to ? "ch-link-active" : ""}`}
                aria-current={pathname === to ? "page" : undefined}
              >
                {label}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}
